import { appEnvironment, appName, isProHost, isProProductionHost } from '@benzinga/utils';

const SEGMENT_DEV_KEY = 'l29fv9xz3v';
const BZ_PROD_KEY = 'gno9YRq4V6rrQSRSROznvuX0U2RfWHP9';
const INDIA_PROD_KEY = 'rN4qRexCcu8RQnOyzH7yqJ3mx8lDKNuN';
const WIDGETS_PROD_KEY = 'g66ovsyaMadCH5LWzJqgWeNKCCGEwdkN';
const PRO_PROD_KEY = 'VCdXF6Dpysf0ApZlvfGszIMrngKN5mYR';
// All lower environments of Benzinga Pro (staging + GitLab branch/preview sandboxes)
// share a dedicated Pro dev write key so their events never land in a production
// Segment source (previously they fell through to BZ_PROD_KEY, the dot_com key).
const PRO_LOWER_ENV_KEY = 'ahec8GwIYfImGvAXWsHoP6eVEBu1AxV2';
const PROPERTIES = ['es', 'fr', 'it', 'jp', 'kr', 'in', 'pro', 'widgets', 'probeta'];

export const getPropertyCodeByHost = (host: string): string => {
  const subdomain = host?.split('.')?.[0];
  return subdomain && PROPERTIES.includes(subdomain) ? subdomain : 'en';
};

export function usesBzWidgetSegmentSource(host: string): boolean {
  if (getPropertyCodeByHost(host) === 'widgets') return true;
  if (process.env['NODE_ENV'] === 'production') return false;
  return appEnvironment().isApp(appName.proto);
}

export function getSegmentKeyForHost(host: string, isProduction: boolean): string {
  // Pro is a single artifact served across prod, staging and preview sandboxes and
  // resolves its key purely by hostname, so classify Pro first (independent of the
  // build-time NODE_ENV flag).
  if (isProHost(host)) return isProProductionHost(host) ? PRO_PROD_KEY : PRO_LOWER_ENV_KEY;
  if (!isProduction) return SEGMENT_DEV_KEY;
  const propertyCode = getPropertyCodeByHost(host);
  if (propertyCode === 'in') return INDIA_PROD_KEY;
  if (propertyCode === 'widgets') return WIDGETS_PROD_KEY;
  if (propertyCode === 'pro' || propertyCode === 'probeta') return PRO_PROD_KEY;
  return BZ_PROD_KEY;
}

export class TrackingEnvironment {
  public static getName = () => 'benzinga-tracking';
  public static getEnvironment = (env: Record<string, string>) => {
    const hostname = window?.location?.hostname ?? '';
    const isProduction = process.env['NODE_ENV'] === 'production';
    // Production Pro keeps its deploy-time injected key as the source of truth. Lower
    // environments must NOT honour the injected key: a preview sandbox on
    // *.sbx.benzinga.com resolves the *production* Pro config (see apps/pro/src/env),
    // so trusting env['segmentKey'] there would send preview events to the prod source.
    if (isProProductionHost(hostname)) {
      const segmentKey = env['segmentKey'] ?? getSegmentKeyForHost(hostname, isProduction);
      return { segmentKey };
    }
    const segmentKey = getSegmentKeyForHost(hostname, isProduction);
    return { segmentKey };
  };
}
